import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from 'redux-store/services/services.utils'

import { Material } from '../../../Materials/api/materialsApi.types'

export const materialUploadApi = createApi({
  reducerPath: 'materialUploadApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    uploadMaterials: builder.mutation<
      Material[],
      {
        practiceId: string
        materials: { file_id: string; name: string }[]
      }
    >({
      query: ({ materials, practiceId }) => ({
        url: `/practices/${practiceId}/materials`,
        method: 'POST',
        body: { materials: materials },
      }),
    }),
  }),
})
